import React from 'react';
import { ProductPack } from '../pack/ProductPack';
import { CtaButton } from '../CtaButton';
import { TrustLine } from '../TrustLine';
export function Hero() {
  return <section className="bg-navy px-5 pb-6 pt-7 text-center text-white" data-id="element-68" data-mp="cvuly4fhadnn">
      <div className="mx-auto max-w-[580px]" data-id="element-69" data-mp="cujjc7xrrby4">
        <h1 className="font-display text-[28px] uppercase leading-[1] md:text-[34px]" data-id="element-70" data-mp="hvh0qiayg1yk">
          The complete <span className="text-gold" data-id="element-71" data-mp="muk7c76l2g8n">visual fault-finding system</span>
          <br className="hidden md:block" data-id="element-72" data-mp="qvm7qrc8kyc7" /> for diesel technicians
        </h1>
        <p className="mx-auto mt-3 max-w-[480px] text-[12px] leading-[1.6] text-white/80" data-id="element-73" data-mp="qtj7lehddotr">
          Stop diagnosing diesel problems from scratch. Use ready-to-use diagnostic workflows, testing guides and fault-finding tools to move from
          symptoms and possible causes to a clearer diagnostic path.{' '}
          <strong className="font-bold text-white" data-id="element-74" data-mp="15ip6108dvb0l">Find the fault. Follow the tests. Diagnose with confidence.</strong>
        </p>
        <div className="mt-4 flex justify-center" data-id="element-75" data-mp="9oc7qlvpvrho">
          <ProductPack width={300} data-id="element-76" data-mp="9p407nu0p93q" />
        </div>
        <div className="mt-4 flex justify-center" data-id="element-77" data-mp="4o6jzgskip4v">
          <CtaButton data-id="element-78" data-mp="4qsspjr73aoo">Yes! I want the complete system</CtaButton>
        </div>
        <p className="mt-2 font-display text-[12px] uppercase tracking-[0.04em] text-gold" data-id="element-79" data-mp="3vvj5g80hhoql">Get Diesel Diagnostic Pro™ today</p>
        <div className="mt-1" data-id="element-80" data-mp="3rviclicn1b00">
          <TrustLine data-id="element-81" data-mp="setw6e9io0x8" />
        </div>
      </div>
    </section>;
}